import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import $ from "jquery";
import moment from "moment";
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Toggle from "react-toggle";
import ActionButton from "../../common/button/actionbutton.component.jsx";
import CreditCardSelector from "../../common/credit-card/creditcardselector.component";
import OnlinePayment from "../../common/credit-card/online-payment.component.jsx";
import GlobalHelper from "../../common/GlobalHelper.jsx";
import Icon from "../../common/icon/icon.component.jsx";
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import { integrationKeyLightspeed } from '../../integration/IntegrationConstants.jsx';
import CreditLimitProtectionButton from '../../invoice/CreditLimitProtectionButton';
import InvoiceHelper from '../../invoice/invoicehelper.jsx';
import TestModeAlert from '../../payment-processing/components/TestModeAlert';
import PaymentTermSelect from "../../payment-term/locationselect.component.jsx";
import CreditCardLabel from "../../payment/creditcard.component.jsx";
import { INTEGRATION_KEY } from "../../state/integration/Constants";
const queryString = require('query-string')


const messages = defineMessages({
    "po_number_placeholder": {
        id: 'embed.ls_retail.new_invoice_modal.po_number_placeholder',
        defaultMessage: 'i.e: PO-1234',
    },
})

class NewInvoiceModalEmbed extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)
        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId,
            date: moment(),
            contactId: this.props.contactId || '',
            contactName: this.props.contactName || '',
            contactExternalId: uri.contactExternalId,
            invoiceExternalId: uri.invoiceExternalId,
            completed: uri.completed || "",
            capturePayment: false,
            loading: true,
            creditCardError: '',
            cardsOnFile: [],
            qmInvoice: null,
            loadingText: '',
            errorMessage: '',
            countryCode: GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()),
            creatingInvoice: false,
            paymentFailed: false,
            creditLimit: 0,
            customerAccount: null,
            invoiceBalance: 0,
            showReceivePaymentModal: false,
            locationId: "",
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.updateSize = this.updateSize.bind(this)
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.handleSubmitExistingCard = this.handleSubmitExistingCard.bind(this)
        this.saveCardOnFile = this.saveCardOnFile.bind(this)
        this.loadingText = this.loadingText.bind(this)
        this.onCardAdded = this.onCardAdded.bind(this)
    }

    componentDidMount() {
        this.updateSize()
        if (this.state.contactExternalId == '0') {
            this.setState({
                loading: false,
            }, () => {
                setTimeout(this.updateSize, 500)
            })
        } else {
            AppContext.getApiClient().post('/contacts/single-import', {
                externalId: this.state.contactExternalId,
                integrationKey: INTEGRATION_KEY.LIGHTSPEED_RETAIL
            }).then(con => {
                if (con.error) {
                    this.setState({
                        loading: false,
                    }, this.updateSize)
                    return
                }
                GlobalHelper.captureFingerprint(location.href, con.attributes.accountId)
                AppContext.getApiClient().get('/payment-terms').then(res => {
                    const term = res.data.filter(t => t.attributes.isDefault)[0]
                    const state = {
                        contactId: con.id,
                        contactName: con.attributes.name,
                        creditLimit: con.attributes.creditLimit,
                        cardsOnFile: con.attributes.cardsOnFile,
                    }
                    this.getCustomerAccount(con.id)
                    if (con.attributes.paymentTermId) {
                        state.paymentTermId = con.attributes.paymentTermId
                    } else if (term) {
                        state.paymentTermId = term.id
                    }
                    this.setState(state, () => {
                        this.updateSize()
                        setTimeout(this.updateSize, 1500)
                        this.getExternalSale(con)
                    })
                })
            })
        }
    }

    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        this.setState({
            errorMessage: '',
            showReceivePaymentModal: false,
        }, () => {
            if (setupIntent && setupIntent.error) {
                this.setState({
                    errorMessage: <div className={"col-12"}>
                        <small className={"text-danger"}>{setupIntent.error.message}</small>
                    </div>,
                }, this.updateSize)
                next()
                return
            } else if (setupIntent && setupIntent.setupIntent) {
                this.saveCardOnFile(setupIntent.setupIntent.payment_method, saveCard, res => {
                    if (res.error) {
                        this.setState({
                            errorMessage: res.error.message
                        }, this.updateSize)
                    }
                    next()
                })
            } else if (token) {
                this.saveCardOnFileWithToken(token, res => {
                    if (res.error) {
                        this.setState({
                            errorMessage: res.error.message
                        }, this.updateSize)
                    }
                    next()
                })
            }
        })
    }

    handleSubmitExistingCard(selectedCreditCard) {
        this.setState({
            showReceivePaymentModal: false,
            defaultCreditCard: selectedCreditCard
        }, this.updateSize)
    }

    saveCardOnFileWithToken(integrationToken, next) {
        let data = {}
        if (integrationToken) {
            data.creditCard = {
                singleUseToken: integrationToken.token || '',
                saveCard: integrationToken.saveCard,
                paymentFlow: 'token',
            }
            if (integrationToken.billingDetails) {
                data.billingDetails = integrationToken.billingDetails
            }
            if (this.state.locationId) {
                data.locationId = this.state.locationId
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
            AppContext.getApiClient().post(`/contacts/${this.state.contactId}/cards-on-file`, data).then(res => {
                if (!res.error) {
                    this.state.cardsOnFile.push(res)
                    this.setState({
                        defaultCreditCard: res
                    }, this.updateSize)
                    if (next) {
                        next(res)
                    }
                } else if (next) {
                    next(res)
                }

            })
        }
    }

    saveCardOnFile(externalPaymentMethodId, saveCard, next) {
        let data = {}
        if (externalPaymentMethodId) {
            data.creditCard = {
                saveCard,
                savedCardToken: externalPaymentMethodId,
                paymentFlow: 'payment-intent',
            }
            if (this.state.locationId) {
                data.locationId = this.state.locationId
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
            AppContext.getApiClient().post(`/contacts/${this.state.contactId}/cards-on-file`, data).then(res => {
                if (!res.error) {
                    this.state.cardsOnFile.push(res)
                    this.setState({
                        defaultCreditCard: res
                    }, this.updateSize)
                    if (next) {
                        next(res)
                    }
                } else if (next) {
                    next(res)
                }

            })
        }
    }

    onCardAdded(newCardOnFile) {
        this.state.cardsOnFile.push(newCardOnFile)
        this.setState({
            defaultCreditCard: newCardOnFile
        }, this.updateSize)
    }

    getExternalSale(contact) {
        let data = {
            limit: "1",
            keywordSaleId: this.state.invoiceExternalId,
            includeIncompleteSales: true,
        }

        AppContext.getApiClient().post(`/${integrationKeyLightspeed}/invoices/importable`, data).then(res => {
            const r = res
            if (r && !r.error && r.data.length > 0) {
                this.setState({
                    invoiceBalance: r.data[0].amount
                }, () => {
                    this.setDefaultCardOnFile(contact, r.data[0].externalLocationId)
                })
            }
        })
    }

    getCustomerAccount(contactId) {
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                customerAccount: res,
            })
        })
    }


    getCustomerOwingBalance() {
        return this.state.customerAccount ? parseFloat(this.state.customerAccount.attributes.owingBalance) : 0
    }


    setDefaultCardOnFile(contact, externalLocationId) {
        if (!contact) {
            return
        }

        const qmLocation = AppContext.locations.find(loc =>
            loc.attributes.externalLinks.find(el =>
                el.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL &&
                el.attributes.type === "location" &&
                el.attributes.externalId === externalLocationId
            )
        )

        let paymentIntegration = null
        const paymentIntegrationKeys = [INTEGRATION_KEY.STRIPE, INTEGRATION_KEY.RAINFOREST]
        if (qmLocation) {
            this.setState({
                locationId: qmLocation.id
            })
            //by priority, we verify whether there's a payment integration whose QM location matches the LS location
            paymentIntegration = AppContext.integrations.find(i =>
                paymentIntegrationKeys.includes(i.attributes.integrationKey) &&
                i.attributes.enabled &&
                i.attributes.locationIds.includes(qmLocation.id)
            )
        }
        if (!paymentIntegration) {
            //if no match, we look for a payment integration without a locationId (All)
            paymentIntegration = AppContext.integrations.find(i =>
                paymentIntegrationKeys.includes(i.attributes.integrationKey) &&
                i.attributes.enabled &&
                //verifies that the location is not already assigned to a disabled integration
                ((qmLocation ? !GlobalHelper.isLocationAssigned(qmLocation.id) : true) && i.attributes.locationIds.length == 0)
            )
        }

        let defaultCreditCard = contact.attributes.cardsOnFile.find(
            card => card.attributes.isDefault && card.attributes.integrationKey == paymentIntegration?.attributes.integrationKey
        )

        this.setState({
            //if no paymentIntegration found, backend won't be able to process credit card payment so don't show option.
            defaultCreditCard: paymentIntegration ? defaultCreditCard : null,
            paymentIntegration: paymentIntegration,
            loading: false,
        })

    }

    closeModal() {
        const data = {
            type: "qm-close-iframe-modal",
        }
        parent.postMessage(data, "*")
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    loadingText(step) {
        const time = 1750
        step = step || 0
        let nextStep = step
        let text = ''
        switch (step) {
            case 0:
                text = <FormattedMessage
                    id="embed.ls_retail.new_invoice_modal.step0_label"
                    defaultMessage="Finalizing Lightspeed sale..."
                />
                nextStep++
                break
            case 1:
                text = <FormattedMessage
                    id="embed.ls_retail.new_invoice_modal.step1_label"
                    defaultMessage="Creating QuoteMachine invoice..."
                />
                if (this.state.capturePayment) {
                    nextStep++
                }
                break
            case 2:
                text = <FormattedMessage
                    id="embed.ls_retail.new_invoice_modal.step1_label"
                    defaultMessage="Creating QuoteMachine invoice..."
                />
                break
        }

        this.setState({
            loadingText: text
        })

        if (nextStep > step) {
            setTimeout(() => {
                this.loadingText(nextStep)
            }, time)
        }
    }

    submit(e) {
        e.preventDefault()
        this.loadingText(0)
        this.setState({
            creatingInvoice: true,
        })
        AppContext.getApiClient().post('/invoices/single-import', {
            externalId: this.state.invoiceExternalId,
            integrationKey: INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            capturePayment: this.state.capturePayment,
            applyPayments: !this.state.capturePayment && this.state.completed === "true",
            invoice: {
                paymentTermId: this.state.paymentTermId,
                poNumber: this.state.poNumber,
            }
        }).then(inv => {
            if (inv.error) {
                this.setState({
                    errorMessage: inv.error.message,
                    creatingInvoice: false,
                    paymentFailed: inv.error.type === 'payment_error',
                }, this.updateSize)
                return
            }
            this.setState({
                qmInvoice: inv,
            }, () => {
                const lastPaymentTransaction = this.state.capturePayment ? inv.attributes.paymentTransactions[inv.attributes.paymentTransactions.length - 1] : null
                if (lastPaymentTransaction && lastPaymentTransaction.attributes.payment.attributes.status === 'declined') {
                    this.setState({
                        creditCardError: lastPaymentTransaction.attributes.payment.attributes.note,
                        qmInvoice: inv,
                        errorMessage: '',
                        loadingText: '',
                        creatingInvoice: false,
                    })
                } else {
                    this.redirectToRegister()
                }
            })
        })
    }

    redirectToRegister() {
        if (this.state.qmInvoice) {
            const data = {
                type: "qm-redirect",
                text: `/register.php?form_name=do_payments&qm_invoice_hash=${this.state.qmInvoice.attributes.proposalHash}&qm_invoice_id=${this.state.qmInvoice.id}&qm_screen=invoice_created`
            }
            parent.postMessage(data, "*")
        }
    }

    isDefaultCreditCardExpired() {
        if (this.state.defaultCreditCard) {
            let today = new Date()
            let creditCardExpirationDate = new Date(
                this.state.defaultCreditCard.attributes.card.attributes.expirationYear,
                (this.state.defaultCreditCard.attributes.card.attributes.expirationMonth - 1)
            )
            return creditCardExpirationDate.getTime() < today.getTime()
        }
        return false
    }

    updateSize() {
        let size = 150
        const elem = document.getElementById('QuoteMachineNewInvoiceEmbedModal')
        if (elem) {
            size = elem.offsetHeight
        }
        const data = {
            type: "qm-size-iframe-modal",
            text: JSON.stringify({
                width: '800px',
                height: `${size}px`,
                padding: '0px',
            })
        }
        parent.postMessage(data, "*")
        $('body').css('overflow', 'hidden')
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        let submitDisabled = false
        if (!this.state.contactId) {
            submitDisabled = true
        }
        if ((this.state.capturePayment && !this.state.defaultCreditCard) || this.state.paymentFailed) {
            submitDisabled = true
        }
        return <div id="QuoteMachineNewInvoiceEmbedModal">
            <div className="modal-body">
                {!this.state.creditCardError &&
                    <div className="container-fluid">
                        <div className="form-group row mb-2">
                            <label className="col-12 col-md-4  col-form-label custom-form-label pb-2" htmlFor="date">
                                <FormattedMessage
                                    id="embed.ls_retail.new_invoice_modal.contact_label"
                                    defaultMessage="Contact"
                                />
                            </label>
                            <div className="col-12 col-md-8 py-2">
                                {!this.state.contactId ? <span className={'text-danger'}>
                                    <Icon value={'exclamation-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="embed.ls_retail.new_invoice_modal.no_contact_message"
                                        defaultMessage="No contact has been selected. Please select a contact before creating an invoice"
                                    />
                                </span> : <a target={'_blank'} href={`/contacts/${this.state.contactId}/edit`}>
                                    {this.state.contactName}
                                </a>}
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label className="col-12 col-md-4  col-form-label custom-form-label pb-2">
                                <FormattedMessage
                                    id="embed.ls_retail.new_invoice_modal.payment_terms_label"
                                    defaultMessage="Payment term"
                                />
                            </label>
                            <div className="col-12 col-md-8">
                                <p className={'mb-2'}>
                                    <PaymentTermSelect
                                        value={this.state.paymentTermId}
                                        onChange={(val) => { this.setState({ paymentTermId: val }) }}
                                    />
                                </p>
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor={'poNumber'} className="col-12 col-md-4  col-form-label custom-form-label pb-2">
                                <FormattedMessage
                                    id="embed.ls_retail.new_invoice_modal.po_number_label"
                                    defaultMessage="PO Number"
                                />
                            </label>
                            <div className="col-12 col-md-8">
                                <input
                                    value={this.state.poNumber}
                                    onChange={this.handleFormChange}
                                    name={'poNumber'}
                                    id={'poNumber'}
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["po_number_placeholder"])}
                                />
                            </div>
                        </div>
                        {this.state.paymentIntegration && !(this.state.completed === "true") &&
                            <div className="form-group row align-items-center mb-0">
                                <label htmlFor={'capturePayment'} className="col-12 col-md-4 col-form-label custom-form-label pb-2">
                                    <Icon value={'credit-card'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="embed.ls_retail.new_invoice_modal.capture_payment_label"
                                        defaultMessage="Use card on file"
                                    />
                                </label>

                                <Toggle
                                    id={'capturePayment'}
                                    className={"ml-3"}
                                    disabled={false}
                                    defaultChecked={this.state.capturePayment}
                                    icons={false}
                                    onChange={() => {
                                        this.setState({
                                            capturePayment: !this.state.capturePayment,
                                            showReceivePaymentModal: false
                                        }, () => {
                                            this.updateSize()
                                            setTimeout(this.updateSize, 500)
                                        })
                                    }} />
                                {this.state.cardsOnFile?.length === 0 && this.state.capturePayment && this.state.defaultCreditCard && <button
                                    type="button"
                                    className="btn-sm btn-primary ml-2"
                                    onClick={() => {
                                        this.setState({ showReceivePaymentModal: !this.state.showReceivePaymentModal }, () => {
                                            this.updateSize()
                                            setTimeout(this.updateSize, 500)
                                        })
                                    }}
                                >
                                    <FormattedMessage
                                        id="embed.ls_retail.new_invoice_modal.use_another_card_label"
                                        defaultMessage="Use another card"
                                    />
                                </button>}

                            </div>
                        }
                        {this.state.showReceivePaymentModal &&
                            <CreditCardSelector
                                onSubmit={this.handleSubmitNewCard}
                                handleSubmitExistingCard={this.handleSubmitExistingCard}
                                updateSize={this.updateSize}
                                cardsOnFile={this.state.cardsOnFile}
                                countryCode={this.state.countryCode}
                                contactId={this.state.contactId}
                            />
                        }
                        {this.state.capturePayment ?
                            <div className="form-group row mb-2">
                                <div className="col-12 col-md-4 col-form-label custom-form-label pb-2">
                                    <FormattedMessage
                                        id="invoice.cards_on_file.will_charge"
                                        defaultMessage="Will charge"
                                    />
                                </div>
                                <div className="col-12 col-md-8">
                                    {this.state.defaultCreditCard ?
                                        <div className='d-flex justify-content-between flex-wrap'>
                                            <div className={this.isDefaultCreditCardExpired() ? 'mb-0 text-danger py-2' : 'mb-0 text-secondary py-2'}>
                                                <p className={'mb-0'}>
                                                    <CreditCardLabel value={this.state.defaultCreditCard.attributes.card} />&nbsp;/&nbsp;{this.state.defaultCreditCard.attributes.card.attributes.cardHolderName}
                                                    {this.isDefaultCreditCardExpired() && <span className="badge badge-danger ml-2 text-white-badge">
                                                        <FormattedMessage
                                                            id="embed.ls_retail.new_invoice_modal.expired_label"
                                                            defaultMessage="Expired"
                                                        />
                                                    </span>}
                                                </p>
                                            </div>
                                            <TestModeAlert className="px-2 py-1 m-0" gap={1} />
                                        </div>
                                        : <div>
                                            <TestModeAlert />
                                            <OnlinePayment
                                                countryCode={this.state.countryCode}
                                                onSubmit={this.handleSubmitNewCard}
                                                submitButton={<FormattedMessage
                                                    id="embed.ls_retail.new_invoice_modal.save_card_btn"
                                                    defaultMessage="Save card on file"
                                                />}
                                                submitDisabled={false}
                                                forceSaveCard={true}
                                                saveAndChargeLater={true}
                                                contactId={this.state.contactId}
                                                showSaveCardComponent={true}
                                                onCardAdded={this.onCardAdded}
                                                locationId={this.state.locationId}
                                            />
                                        </div>}
                                </div>
                            </div> : null}
                        {this.state.showReceivePaymentModal && <receivepaymentmodal />}
                    </div>
                }
                {this.state.creditCardError && this.state.qmInvoice &&
                    <div className="container-fluid">
                        <h5 className="text-danger text-center">
                            <FormattedMessage
                                id="embed.ls_retail.new_invoice_modal.payment_failed_message"
                                defaultMessage="The credit card payment has failed with the following error: {errorMessage}"
                                values={{
                                    errorMessage: this.state.creditCardError,
                                }}
                            />
                        </h5>
                        <h5 className="text-center">
                            <FormattedMessage
                                id="embed.ls_retail.new_invoice_modal.payment_failed_go_to_quotemachine"
                                defaultMessage="To try another payment on the newly created {invoiceIdentifier}, please go to QuoteMachine."
                                values={{
                                    invoiceIdentifier: <a href={`https://qmach.in/invoices/${this.state.qmInvoice.id}/edit`} target="_blank" rel='noopener noreferrer'
                                        onClick={e => {
                                            this.redirectToRegister()
                                            return true
                                        }}>
                                        {this.state.qmInvoice.attributes.identifier}</a>
                                }}
                            />
                        </h5>
                        <div className="col-12 d-flex justify-content-center mt-4">
                            <a className="btn-primary btn btn-lg" href={`https://qmach.in/invoices/${this.state.qmInvoice.id}/edit`} target="_blank" rel='noopener noreferrer'
                                onClick={e => {
                                    this.redirectToRegister()
                                    return true
                                }}>
                                <FormattedMessage
                                    id="embed.ls_retail.new_invoice_modal.open_qm_invoice"
                                    defaultMessage="Open {invoiceIdentifier}"
                                    values={{
                                        invoiceIdentifier: this.state.qmInvoice.attributes.identifier,
                                    }}
                                />
                            </a>
                        </div>
                    </div>
                }
            </div>
            <div className="modal-footer d-flex justify-content-end">
                <div className={'mr-2 text-secondary'}>
                    <small>{this.state.loadingText}</small>
                </div>
                <div className={'mr-2 text-danger'}>
                    <small>{this.state.errorMessage}</small>
                </div>
                <div>
                    {!this.state.creditCardError && this.state.capturePayment &&
                        [<button type="button" className="btn btn-secondary mr-2" onClick={e => {
                            e.preventDefault()
                            this.closeModal()
                        }}>
                            <FormattedMessage
                                id="invoice.account_statement_modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>,
                        <ActionButton
                            type="button"
                            className="btn btn-success"
                            onClick={this.submit}
                            disabled={submitDisabled}
                            isLoading={this.state.creatingInvoice}
                        >
                            <Icon value={'credit-card'} className={'mr-1'} />
                            <FormattedMessage
                                id="embed.ls_retail.invoice_modal.create_and_charge_btn"
                                defaultMessage="Create and charge invoice"
                            />
                        </ActionButton>
                        ]
                    }
                    {!this.state.creditCardError && !this.state.capturePayment &&
                        [<button type="button" className="btn btn-secondary mr-2" onClick={e => {
                            e.preventDefault()
                            this.closeModal()
                        }}>
                            <FormattedMessage
                                id="invoice.account_statement_modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>,
                        <CreditLimitProtectionButton
                            owingBalance={Number(this.getCustomerOwingBalance())}
                            invoiceBalance={Number(this.state.invoiceBalance)}
                            creditLimit={Number(this.state.creditLimit)}
                            buttonClassName={"btn btn-outline-success mr-2"}
                            onClickEventCallback={this.submit}
                            buttonIcon={<Icon value={'bullseye'} className={'mr-1'} />}
                            buttonLabel={<FormattedMessage
                                id="embed.ls_retail.invoice_modal.create_btn"
                                defaultMessage="Create invoice"
                            />}
                            isDisabled={submitDisabled}
                            allowedModalMessage={InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
                                this.state.customerAccount?.attributes.owingBalanceCurrency, this.getCustomerOwingBalance(), this.state.invoiceBalance,
                                this.state.creditLimit, true)}
                            deniedModalMessage={InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
                                this.state.customerAccount?.attributes.owingBalanceCurrency, this.getCustomerOwingBalance(), this.state.invoiceBalance,
                                this.state.creditLimit, false)}>
                        </CreditLimitProtectionButton>]}
                    {this.state.creditCardError && this.state.qmInvoice &&
                        <button type="button" className="btn btn-secondary mr-2" onClick={e => {
                            e.preventDefault()
                            this.redirectToRegister()
                        }}>
                            <FormattedMessage
                                id="invoice.account_statement_modal.back_to_register_btn"
                                defaultMessage="Back to register"
                            />
                        </button>
                    }
                </div>
            </div>
        </div >
    }
}

export default injectIntl(NewInvoiceModalEmbed)


// WEBPACK FOOTER //
// ./src/embed/ls-retail/newinvoicemodal.component.jsx